"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionLineageCountsQueryWrapper = void 0;
var components_1 = require("@apollo/client/react/components");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var LineageCountsFunctions_1 = require("../lineage/LineageCountsFunctions");
function createUnfilteredCounts(data) {
    var _a;
    var virtualConnection = data.virtualConnections && data.virtualConnections[0];
    if (virtualConnection
        && virtualConnection.unfilteredTablesConnection
        && virtualConnection.upstreamDatabasesConnection
        && virtualConnection.upstreamTablesConnection
        && virtualConnection.downstreamFlowsConnection
        && virtualConnection.downstreamDatasourcesConnection
        && virtualConnection.downstreamWorkbooksConnection
        && virtualConnection.downstreamSheetsConnection
        && virtualConnection.downstreamDashboardsConnection
        && virtualConnection.downstreamMetricsConnection
        && virtualConnection.downstreamOwnersConnection) {
        return {
            filteredFieldName: null,
            tables: virtualConnection.unfilteredTablesConnection.totalCount,
            upstreamDatabases: virtualConnection.upstreamDatabasesConnection.totalCount,
            upstreamTables: virtualConnection.upstreamTablesConnection.totalCount,
            downstreamFlows: virtualConnection.downstreamFlowsConnection.totalCount,
            downstreamDatasources: virtualConnection.downstreamDatasourcesConnection.totalCount,
            downstreamWorkbooks: virtualConnection.downstreamWorkbooksConnection.totalCount,
            downstreamLenses: ((_a = virtualConnection.downstreamLensesConnection) === null || _a === void 0 ? void 0 : _a.totalCount) || 0,
            downstreamSheets: virtualConnection.downstreamSheetsConnection.totalCount,
            downstreamDashboards: virtualConnection.downstreamDashboardsConnection.totalCount,
            downstreamMetrics: virtualConnection.downstreamMetricsConnection.totalCount,
            downstreamOwners: virtualConnection.downstreamOwnersConnection.totalCount,
        };
    }
    return null;
}
function createFilteredCounts(data) {
    var _a, _b;
    var virtualConnection = data.virtualConnections && data.virtualConnections[0];
    var filteredTable = virtualConnection && virtualConnection.filteredTablesConnection && virtualConnection.filteredTablesConnection.nodes[0];
    if (virtualConnection
        && virtualConnection.unfilteredTablesConnection
        && filteredTable
        && filteredTable.upstreamDatabasesConnection
        && filteredTable.upstreamTablesConnection
        && filteredTable.downstreamFlowsConnection
        && filteredTable.downstreamDatasourcesConnection
        && filteredTable.downstreamWorkbooksConnection
        && filteredTable.downstreamSheetsConnection
        && filteredTable.downstreamDashboardsConnection
        && filteredTable.downstreamMetricsConnection
        && filteredTable.downstreamOwnersConnection) {
        return {
            filteredFieldName: (_a = filteredTable === null || filteredTable === void 0 ? void 0 : filteredTable.name) !== null && _a !== void 0 ? _a : null,
            tables: virtualConnection.unfilteredTablesConnection.totalCount,
            upstreamDatabases: filteredTable.upstreamDatabasesConnection.totalCount,
            upstreamTables: filteredTable.upstreamTablesConnection.totalCount,
            downstreamFlows: filteredTable.downstreamFlowsConnection.totalCount,
            downstreamDatasources: filteredTable.downstreamDatasourcesConnection.totalCount,
            downstreamLenses: ((_b = filteredTable.downstreamLensesConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            downstreamWorkbooks: filteredTable.downstreamWorkbooksConnection.totalCount,
            downstreamSheets: filteredTable.downstreamSheetsConnection.totalCount,
            downstreamDashboards: filteredTable.downstreamDashboardsConnection.totalCount,
            downstreamMetrics: filteredTable.downstreamMetricsConnection.totalCount,
            downstreamOwners: filteredTable.downstreamOwnersConnection.totalCount
        };
    }
    return null;
}
var VirtualConnectionLineageCountsQueryWrapper = /** @class */ (function (_super) {
    __extends(VirtualConnectionLineageCountsQueryWrapper, _super);
    function VirtualConnectionLineageCountsQueryWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VirtualConnectionLineageCountsQueryWrapper.prototype.render = function () {
        var _this = this;
        var selectedFields = Object.keys(this.props.selectedTableKeys);
        if (selectedFields.length > 0) {
            var selectedTableId_1 = selectedFields[0];
            return (react_1.default.createElement(data_catalog_shared_1.FeatureFlagsContext.Consumer, null, function (_a) {
                var lensLineageEnabled = _a.lensLineageEnabled;
                return react_1.default.createElement(components_1.Query, { query: queries_1.VirtualConnectionLineageCountsFilteredByTableDocument, variables: {
                        vizportalUrlId: _this.props.vizportalUrlId,
                        selectedTableId: selectedTableId_1,
                        lensLineageEnabled: lensLineageEnabled,
                    } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderFilteredLineageCounts)(result, createUnfilteredCounts, createFilteredCounts, _this.props.children)); });
            }));
        }
        else {
            return (react_1.default.createElement(data_catalog_shared_1.FeatureFlagsContext.Consumer, null, function (_a) {
                var lensLineageEnabled = _a.lensLineageEnabled;
                return react_1.default.createElement(components_1.Query, { query: queries_1.VirtualConnectionLineageCountsDocument, variables: {
                        vizportalUrlId: _this.props.vizportalUrlId,
                        lensLineageEnabled: lensLineageEnabled,
                    } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderUnfilteredLineageCounts)(result, createUnfilteredCounts, _this.props.children)); });
            }));
        }
    };
    return VirtualConnectionLineageCountsQueryWrapper;
}(react_1.default.Component));
exports.VirtualConnectionLineageCountsQueryWrapper = VirtualConnectionLineageCountsQueryWrapper;
//# sourceMappingURL=VirtualConnectionCountsQueryWrapper.js.map